<div class="privacy-policy-container">
  <div class="loading-spinner" *ngIf="isLoading">
    <div class="spinner"></div>
    <p>Loading privacy policy...</p>
  </div>

  <div class="error-message" *ngIf="errorMessage">
    <div class="error-icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
        <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
        <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
      </svg>
    </div>
    <p>{{ errorMessage }}</p>
    <button class="retry-button" (click)="loadPrivacyPolicy()">Try Again</button>
  </div>

  <div class="privacy-content" *ngIf="!isLoading && !errorMessage" [innerHTML]="privacyPolicyContent"></div>
</div>

